import { render, staticRenderFns } from "./top-statement.vue?vue&type=template&id=73d8c9a0&scoped=true&"
import script from "./top-statement.vue?vue&type=script&lang=js&"
export * from "./top-statement.vue?vue&type=script&lang=js&"
import style0 from "./top-statement.vue?vue&type=style&index=0&id=73d8c9a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d8c9a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
